import {makeAutoObservable} from "mobx";

export default class ParametresSystemeStore {
    viewHome = true
    viewGeneral = false;
    viewEquipes = false;
    viewObjectifs = false;

    constructor() {
        makeAutoObservable(this);
    }

    resetViews(){
        this.viewHome = true;
        this.viewGeneral = false;
        this.viewEquipes = false;
        this.viewObjectifs = false;
    }

    handleViewGeneral(){
        this.viewHome = false;
        this.viewGeneral = true;
        this.viewEquipes = false;
        this.viewObjectifs = false;
    }

    handleViewEquipes(){
        this.viewHome = false;
        this.viewGeneral = false;
        this.viewEquipes = true;
        this.viewObjectifs = false;
    }

    handleViewObjectifs(){
        this.viewHome = false;
        this.viewGeneral = false;
        this.viewEquipes = false;
        this.viewObjectifs = true;
    }
}